import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddAccountApiParameter, storeCreateAccount as addAccountApi } from "@store/Services/StoreCreateAccountService";
import { StoreAccountModel } from "@store/Types/ApiModels";

export interface AddAccountParameter {
    company: string;
    address: string;
    postal: string;
    city: string;
    province: string;
    phone: string;
    fax: string;
    deliveryAddressRadio: string;
    shipAddress: string;
    shipPostal: string;
    shipCity: string;
    shipProvince: string;
    shipPhone: string;
    shipFax: string;
    companysOwnerRadio: string;
    ownersName: string;
    firstName: string;
    lastName: string;
    email: string;
    personsTitle: string;
    otherTitle: string;
    extraPerson: boolean;
    extraFirstName: string;
    extraLastName: string;
    extraEmail: string;
    extraPersonsTitle: string;
    extraOtherTitle: string;
    operationSince: string;
    activityField: string;
    translateActivityFieldSpecifyBox: string;
    activityFieldSpecifyBox: string;
    poNumberRadio: string;
    purchasesPlanned: string;
    comments: string;
    legalAgreement: boolean;
    onSuccess?: (results: any) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    AddAccountParameter,
    AddAccountApiParameter,
    ServiceResult<StoreAccountModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        account: {
            ...props.parameter,
        } as StoreAccountModel,
    };
};

export const StoreCreateAccount: HandlerType = async props => {
    props.apiResult = await addAccountApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [PopulateApiParameter, StoreCreateAccount, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const storeCreateAccount = createHandlerChainRunner(chain, "StoreCreateAccount");
export default storeCreateAccount;
